export const getLinkDocumento = (origin, data) => {
  let link = `${origin}/`;

  if (data.Tipo === "Factura Cliente") {
    link += "Facturacion/factura_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Factura Suplidor") {
    link += "CxP/factura_suplidor_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Recibo") {
    link += "CxC/recibo_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Anticipo CxC") {
    link += "CxC/anticipo_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Anticipo CxP") {
    link += "CxP/anticipo_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Cargo Bancario") {
    link += "Activos/cargo_bancario_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Credito Bancario") {
    link += "Activos/credito_bancario_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Cierre de Caja") {
    link += "Facturacion/cierre_caja_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Conduce") {
    link += "Facturacion/conduce_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Deposito Bancario") {
    link += "Activos/deposito_bancario_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Transferencia Bancaria") {
    link += "Activos/transferencia_bancaria_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Entrada a Almacén") {
    link += "Inventario/entrada_almacen_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Gasto") {
    link += "Contabilidad/gastos_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Nota de Crédito (CxC)") {
    link += "CxC/nota_credito_cxc_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Nota de Débito (CxC)") {
    link += "CxC/nota_debito_cxc_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Nota de Crédito (CxP)") {
    link += "CxP/nota_credito_cxp_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Nota de Débito (CxP)") {
    link += "CxP/nota_debito_cxp_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Salida de Almacén") {
    link += "Inventario/salida_almacen_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Traslado de Almacén") {
    link += "Inventario/traslado_almacen_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Devolución de Anticipo") {
    link += "CxC/devolucion_anticipo_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Prestamo") {
    link += "Nomina/prestamo_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Diario") {
    link += "Contabilidad/diario_edit.aspx?IdSec=" + data.Referencia;
  } else if (data.Tipo === "Cheque") {
    link += "Activos/cheque_edit.aspx?IdSec=" + data.Referencia;
  } else {
    link = "";
  }

  return link;
};

export const getLinkDiario = (origin, data) => {
  const link = `${origin}/`;

  return link + "Contabilidad/diario_edit.aspx?IdSec=" + data.Numero;
};
